export const convertCSSDuration = (value) => {
    const list = value.match(/^([\d\.]+)(s|ms)$/);
    if (!list)
        throw new Error();
    const number = Number(list[1]);
    if (list[2] === 's')
        return number * 1000;
    return number;
};
